import { Loader2, Play } from 'lucide-react';
import React from 'react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { useCreateProofreadingJobMutation } from '@/services/api/proofreadingService';

interface StartProofreadingJobButtonProps {
  matterId: string;
  workspaceId: string;
  /** Callback when the job is successfully created */
  onJobCreated?: (jobId: string) => void;
}

export const StartProofreadingJobButton: React.FC<
  StartProofreadingJobButtonProps
> = ({ matterId, workspaceId, onJobCreated }) => {
  const [createJobMutation, { isLoading }] = useCreateProofreadingJobMutation();

  const handleStartJob = async () => {
    try {
      const job = await createJobMutation({ matterId, workspaceId }).unwrap();
      toast.success('Proofreading job started successfully');
      onJobCreated?.(job.id);
    } catch (error) {
      console.error(error);
      toast.error('Failed to start proofreading job');
    }
  };

  return (
    <Button
      onClick={handleStartJob}
      disabled={isLoading}
      className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 shadow-lg hover:shadow-xl transition-all duration-200"
      size="lg"
    >
      {isLoading ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Starting Analysis...
        </>
      ) : (
        <>
          <Play className="mr-2 h-4 w-4" />
          Start Proofreading Analysis
        </>
      )}
    </Button>
  );
};
